import isNil from 'lodash/isNil'
import { useCallback } from 'react'

import { useInvoiceEditorBaseCurrency } from '../..../../../../../../hooks/useInvoiceEditorBaseCurrency'
import { useInvoiceEditorForm } from '../../../../../contexts/invoiceEditorFormContext'

export const useUpdateDependentCurrencies = () => {
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { baseCurrency } = useInvoiceEditorBaseCurrency()

  const { setValue, getValues } = invoiceEditorForm

  const handleExchangeRateChange = useCallback(
    (exchangeRate?: number) => {
      if (isNil(exchangeRate)) {
        return
      }

      const currency = getValues('currency')
      const exchangeRateValue = currency !== baseCurrency ? exchangeRate : undefined

      setValue('exchangeRate', exchangeRateValue)
    },
    [baseCurrency, getValues, setValue],
  )

  return {
    handleExchangeRateChange,
  }
}
